import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { AngularMaterialsModules } from '../../../module/materials.module'
import { Agent } from '../models/agent.models'

@Component({
  selector: 'ddc-agents-list',
  templateUrl: './ddc-agents-list.component.html',
  styleUrls: ['./ddc-agents-list.component.scss'],
  standalone: true,
  imports: [CommonModule, AngularMaterialsModules],
})
export class DdcAgentsListComponent {
  @Input() agents: Agent[] = []
  @Input() selectedAgentId: number | undefined
  @Input() theme: string = 'light-theme'

  @Output() agentSelected = new EventEmitter<Agent>()
  @Output() createAgentClicked = new EventEmitter<void>()

  select(agent: Agent): void {
    this.agentSelected.emit(agent)
  }
}
